/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import { useEffect, useState } from 'react';
import OrgChart from 'react-orgchart';
import 'react-orgchart/index.css';
import { formatNumberDecimals } from 'utils/formats';

import diagramTypes from 'constants/diagramTypes';

import CompanyLogo from 'assets/images/logo-company.png';
import addAbsolutePercents from '../OrganizationChart/utils/addAbsolutePercents';
import ChartItem from '../OrganizationChart/components/ChartItem';

const AdministratedPortfolio = ({
  trees = [], // pass your partner/administrated trees here
  diagramType = diagramTypes.HOLDING,
}) => {
  const [chartData, setChartData] = useState(null);

  const getPercentInfo = (ndPercentage, fdPercentage) => {
    const prefix = `${formatNumberDecimals(ndPercentage || 0)}% ND`;
    const suffix = `${formatNumberDecimals(fdPercentage || 0)}% FD`;

    return `${prefix} / ${suffix}`;
  };

  // Helper to map backend tree to chart node format
  const mapTreeToChartNode = (node) => {
    if (!node) return null;

    return {
      id: node.id.toString(),
      name: node.name || '',
      logo: node?.logo || CompanyLogo,
      data: node.isRoot
        ? node.cif
        : `${getPercentInfo(node.ndPercent, node.fdPercent)}`,
      shares: node.sharesCount?.toString() || '',
      percent: getPercentInfo(node.ndPercent, node.fdPercent),
      percentNdValue: node.ndPercent || 0,
      percentFDValue: node.fdPercent || 0,
      userType: node.userType || false,
      email: node.email || '',
      tooltip: `${node.name}\n: ${getPercentInfo(
        node.ndPercent,
        node.fdPercent
      )}`,
      children: node.children?.map(mapTreeToChartNode) || [],
    };
  };

  useEffect(() => {
    if (!trees.length) return;

    const mapedChartData = mapTreeToChartNode(trees[0]);

    console.log('Mapped Chart Data:', mapedChartData); // Debug log to check the mapped data

    const chartWithAbsolutePercents = addAbsolutePercents(mapedChartData);

    setChartData(mapedChartData);
  }, [trees]);

  // Optional: center scroll
  useEffect(() => {
    const container = document.querySelector('.reactOrgChart');
    const content = document.querySelector('.orgNodeChildGroup');

    if (!container || !content) return;

    container.scrollLeft = (content.clientWidth - container.clientWidth) / 2;
  }, [chartData]);

  if (!chartData) return null;

  return (
    <div className="nk-block chart-container chart-container__bordered">
      <OrgChart tree={chartData} NodeComponent={ChartItem} />
      <div className="fading-effect" />
    </div>
  );
};

export default AdministratedPortfolio;
